import * as types from './actionTypes';
import {api} from './api';

export function getSystemInformation() {
    return api({
        types: [types.APP__GET_SYSTEM_INFORMATION_REQUEST, types.APP__GET_SYSTEM_INFORMATION_SUCCESS, types.APP__GET_SYSTEM_INFORMATION_FAILURE],
        uri: '/api/systeminfo',
        sendJwtBearer: false,
        config: {
            method: 'get',
            headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/json'
            }
        },
        payload: {  }
    });
}